import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MweConstants } from 'src/app/constants/mwe-constants.service';
import { ListColumn } from 'src/app/models/list-column.model';
import { EndCustomerService } from 'src/app/services/end-customer.service';
import { SweetAlertService } from 'src/app/services/sweetalert.service';

@Component({
  selector: 'app-certification-profile',
  templateUrl: './certification-profile.component.html',
  styleUrls: ['./certification-profile.component.scss']
})
export class CertificationProfileComponent implements OnInit{
  @ViewChildren(MatAutocompleteTrigger) autoCompletes!: QueryList<MatAutocompleteTrigger>;

  certificateColumns: ListColumn[] = [
    { name: 'Name', property: 'name', visible: true, isModelProperty: true ,isText: true},
    { name: 'Organization Name', property: 'organizationName', visible: true, isModelProperty: true ,isText: true},
    { name: 'Year', property: 'year', visible: true, isModelProperty: true ,isText: true},
    { name: 'Certificate', property: 'fileName', visible: true, isModelProperty: true ,isFileDownload: true},
  ] as ListColumn[];
  @Input() showPersonalInfo:boolean=false;
  @Input() certificationsForm!:FormGroup;
  @Input() endCustomerData:any;
  showEditForm:boolean=false;
  copyCertificationForm:any;
  data:any=[];
  certificateIcon:string="assets/images/Certifications.svg";
  @Output() onUpdate:EventEmitter<any>=new EventEmitter();
  yearDropdown:any=[];
  yearControl = new FormControl('');
  filteredYears: { [key: number]: number[] } = {};

  ngOnInit(): void {
    this.data=JSON.parse(JSON.stringify( this.certificationsForm.get('certifications')?.value));
    this.applyValidators();
    this.getYearDropdown();   

    this.certifications.controls.forEach((control, index) => {
      this.filteredYears[index] = [...this.yearDropdown]; // Initialize for each field
      control.get('year')?.valueChanges.subscribe(() => this.filterYears(index));
  });
   }
  

  constructor(private fb:FormBuilder,private endCustomerService:EndCustomerService,private sweetalertService:SweetAlertService){
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  get certifications() {
    return this.certificationsForm.controls["certifications"] as FormArray;
  } 
  applyValidators(): void {
    const nameValidators = [
        Validators.pattern(/^[A-Za-z .]+$/),
        Validators.maxLength(50)
    ];

    const organizationValidators = [
        Validators.pattern(/^[A-Za-z0-9\s&.]+$/),
        Validators.maxLength(150)
    ];

    const fileValidators = [
        Validators.pattern(/^.*\.(jpg|jpeg|png|pdf)$/i)
    ];

    if (this.certifications && this.certifications.controls.length) {
        this.certifications.controls.forEach((control) => {
            const certificationControl = control as FormGroup;
            certificationControl.get('name')?.setValidators(nameValidators);
            certificationControl.get('organizationName')?.setValidators(organizationValidators);
            certificationControl.get('fileName')?.setValidators(fileValidators);

            certificationControl.get('name')?.updateValueAndValidity();
            certificationControl.get('organizationName')?.updateValueAndValidity();
            certificationControl.get('fileName')?.updateValueAndValidity();
        });
    }
  }
  filterYears(index: number) {
    const searchTerm = this.certifications.at(index).get('year')?.value?.toString() || '';
    this.filteredYears[index] = this.yearDropdown.filter((year:number) => 
        year.toString().includes(searchTerm)
    );
}

onYearSelected(event: any, index: number) {
    this.certifications.at(index).get('year')?.setValue(event.option.value);
}

scrollEvent = (event: any): void => {
  const target = event.target as HTMLElement
  const isScrollingInsidePanel = this.autoCompletes.some(autoComplete => {
    if(autoComplete.panelOpen){
      const panel = autoComplete.autocomplete.panel;
      return panel && panel.nativeElement.contains(target);
    }
    return false;
  })
  if(!isScrollingInsidePanel){
    this.closeAllPanels();
  }
}

closeAllPanels() {
  this.autoCompletes.forEach(autoComplete => {
    if (autoComplete.panelOpen) {
      autoComplete.closePanel();
    }
  });
}
  addCertificationsAndLicense(){
    this.copyCertificationForm=JSON.parse(JSON.stringify(this.certificationsForm.value));
    this.certifications.push( this.fb.group({
      "name"  :new FormControl(null),
      "organizationName":new FormControl(null),
      "year":new FormControl(null),
      "certificate":new FormControl(null),
       fileName:new FormControl(null)
     }),)
     this.applyValidators();
     this.showEditForm=true;
  }

  editCertificationsAndLicense(){
    this.copyCertificationForm=JSON.parse(JSON.stringify(this.certificationsForm.value));
    this.showEditForm=true;
    
  }
  update(){
    this.updateCertifications();
    this.certifications.markAllAsTouched();
    this.applyValidators();
    if(this.certifications.invalid){
      return;
    }
    this.onUpdate.emit(50);
  }

  refresh(){
    this.showEditForm=false;
   this.data=JSON.parse(JSON.stringify( this.certificationsForm.get('certifications')?.value));
  }

  updateCertifications(){
    for(let i=0;i<this.certifications.controls.length;i++){
      if(!(this.certifications.at(i).get('name')?.value==null || this.certifications.at(i).get('name')?.value=='')||
        !(this.certifications.at(i).get('organizationName')?.value==null || this.certifications.at(i).get('organizationName')?.value=='')
        ||(this.certifications.at(i).get('year')?.value!=null)||
        this.certifications.at(i).get('certificate')?.value!=null  ){
          
        this.certifications.at(i).get('name');
        this.certifications.at(i).get('organizationName');
        this.certifications.at(i).get('year');
        this.certifications.at(i).get('certificate');

      }else{
        this.certifications.at(i).get('name')?.clearValidators();
        this.certifications.at(i).get('organizationName')?.clearValidators();
        this.certifications.at(i).get('year')?.clearValidators();
        this.certifications.at(i).get('certificate')?.clearValidators();
      
      }
      this.certifications.at(i).get('name')?.updateValueAndValidity();
      this.certifications.at(i).get('organizationName')?.updateValueAndValidity();
      this.certifications.at(i).get('year')?.updateValueAndValidity();
      this.certifications.at(i).get('certificate')?.updateValueAndValidity();
    }
  }

  cancel(){
    
    (this.certificationsForm.get('certifications')as FormArray).clear();
     if(this.copyCertificationForm?.certifications && this.copyCertificationForm.certifications.length>0){
          for(let i=0;i<this.copyCertificationForm.certifications.length;i++){
            if(this.copyCertificationForm.certifications[i].name!=null ||this.copyCertificationForm.certifications[i].organizationName!=null ||this.copyCertificationForm.certifications[i].year!=null ||
               this.copyCertificationForm.certifications[i].certificate!=null || this.copyCertificationForm.certifications[i].fileName!=null ){
              (this.certificationsForm.get('certifications')as FormArray).push( this.fb.group({
                id:new FormControl(this.copyCertificationForm.certifications[i].id),
                active:new FormControl(this.copyCertificationForm.certifications[i].active),
                createdBy:new FormControl(this.copyCertificationForm.certifications[i].createdBy),
                createdOn:new FormControl(this.copyCertificationForm.certifications[i].createdOn),
                modifiedBy:new FormControl(this.copyCertificationForm.certifications[i].modifiedBy),
                modifiedOn:new FormControl(this.copyCertificationForm.certifications[i].modifiedOn),
                "name"  :new FormControl(this.copyCertificationForm.certifications[i].name),
                "organizationName"  :new FormControl(this.copyCertificationForm.certifications[i].organizationName),
                "year"  :new FormControl(this.copyCertificationForm.certifications[i].year),
                "certificate":new FormControl(this.copyCertificationForm.certifications[i].certificate),
                fileName:new FormControl(this.copyCertificationForm.certifications[i].fileName)
              }));
            }
          }
          (this.certificationsForm.get('certifications')as FormArray).patchValue(this.copyCertificationForm.certifications);
        }
       
    this.showEditForm=false;
    this.data=JSON.parse(JSON.stringify( this.certificationsForm.get('certifications')?.value));
   
  
  
  }

  uploadCertificate(event:any,i:number){
    let uploadData = new FormData();
     uploadData.append('file', event.target.files[0]);
     let randomNumber = Math.floor(Math.random() * 10) + 1
     uploadData.append('destinationKey', randomNumber+'');
     
     const fileExtension = event.target.files[0].name.split('.').pop()?.toLowerCase();
    if (fileExtension !== 'pdf' && fileExtension !== 'png' && fileExtension!=='jpeg' && fileExtension!=='jpg') {
      this.sweetalertService.showError('Error', 'Only pdf, png, jpeg and jpg files are allowed');
      return;
    }
 
     this.endCustomerService.executePostRequestForAuth(MweConstants.uploadFile,uploadData).subscribe(data=>{
       if(data && data?.data){
        this.certifications.at(i).get('certificate')?.patchValue(data.data);
        this.certifications.at(i).get('fileName')?.patchValue(event.target.files[0].name);
       }
     },error=>{
 
     })
  }

  deleteCertificationsAndLicense(i:number){
    this.certifications.removeAt(i);
  }

  clearCertificate(i:number){
    this.certifications.at(i).get('certificate')?.reset();
    this.certifications.at(i).get('fileName')?.reset();
  }

  selectedAction(event:any){
    switch (event.action) {
      case MweConstants.fileDownloadAction:
        window.open(event.row?.certificate,'_blank');
        break;
    
      default:
        break;
    }
  }
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.preventDefault(); 
    }
  }
  getYearDropdown(){
    for(let year=new Date().getFullYear();year>=1947;year--){
      this.yearDropdown.push(year);
    }
  }
}
